import { useState, useEffect } from "react";
import { Space, Row, Col, Typography, Divider } from "antd";
import { FileExcelOutlined, FormOutlined, ToolOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { useContext } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { UserContext } from "../Context";
import { IResourcesData } from "../ProactiveHeader";
import eventTrack, { actionNames, categoryNames } from "../../Utils/Tracking/EventTracking";
import { colorCodes } from "../../Styles";

const { Text } = Typography;

const AppDrawerFormat = styled(Row)`
  & {
    min-width: 400px;
    max-width: 420px;
  }
  .anticon {
    font-size: 30px;
    display: inline-block;
  }
  .icon {
    font-size: 30px;
    display: inline-block;
    line-height: 0;
    vertical-align: -0.125em;
  }
  img {
    height: 30px;
  }
  .ant-divider-horizontal {
    margin: 0px 0px 0px -16px;
    min-width: 108%;
    &.top {
      margin-top: 24px;
    }
    &.bottom {
      margin-bottom: 24px;
    }
  }
  .title {
    padding: 5px 0px 4px;
    font-weight: 500;
  }
  .app {
    text-align: center;
  }
  padding: 20px 0px 16px 0px;
`;

const IconLink = styled(Link)`
  margin: 1rem;
  display: inline-block;
`;

export const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

const AppDrawer = (pr: { control: (a: boolean) => void; DTAUrl: string; resources: IResourcesData[] }) => {
  const role = useContext(UserContext).value?.role || "";
  const type = useContext(UserContext).value?.type || "";
  const restriction = useContext(UserContext).value?.restriction || "";
  const isImpersonate = useContext(UserContext).value?.isImpersonate || "";
  
  return (
    <AppDrawerFormat>
      {role !== "CP" && (
      <Col span={6} className="app">
        <Link to="/custom-query" 
          onClick={(e) => {
            if (restriction === "ACCOUNT") {
              e.preventDefault();
              return;
            }
            pr.control(false)
            eventTrack({
              category: categoryNames.header,
              action: actionNames.click,
              label: "Custom Query",
            }); 
          }}
          style={restriction === "ACCOUNT" ? { color: colorCodes.textGrey, opacity: 0.5, pointerEvents: "none" } : {}}>
          <Space direction="vertical" align="center">
            <FileExcelOutlined />
            <Text>Custom Query</Text>
          </Space>
        </Link>
      </Col>
      )}
      {role !== "CP" && pr.DTAUrl !== '' && (
        <Col span={6} className="app">
          <a onClick={() => {
            openInNewTab(pr.DTAUrl)
            pr.control(false)
            eventTrack({
              category: categoryNames.header,
              action: actionNames.click,
              label: "DTA Installer",
            }); 
          }}>
            <Space direction="vertical" align="center" >
              <ToolOutlined/>
              <Text>DTA Installer (VPN Required)</Text>
            </Space>
          </a>
        </Col>
      )}
      {role === "ADMIN" && (
        <Col span={6} className="app">
          <Link to="/alert-cms" 
            onClick={() => {
              pr.control(false)
              eventTrack({
                category: categoryNames.header,
                action: actionNames.click,
                label: "Alert CMS",
              }); 
            }}>
            <Space direction="vertical" align="center">
              <FormOutlined />
              <Text>Alert CMS</Text>
            </Space>
          </Link>
        </Col>
      )}
      {(role === "ADMIN" || isImpersonate === true) && (
        <Col span={6} className="app">
          <Link to="/user-spoofing" 
            onClick={() => {
              pr.control(false)
              eventTrack({
                category: categoryNames.header,
                action: actionNames.click,
                label: "User Spoofing",
              }); 
            }}>
            <Space direction="vertical" align="center">
              <UserSwitchOutlined />
              <Text>User Spoofing</Text>
            </Space>
          </Link>
        </Col>
      )}
      {role !== "CP" && pr.resources.length > 0 && (
        <>
          <Divider className="top"/>
            <div className="title">Resources</div>
          <Divider className="bottom"/>
          {pr.resources.map((resource: IResourcesData, ind: number) => 
            <Col span={6} className="app">
              <a onClick={() => {
                pr.control(false)
                openInNewTab(resource.value)
                eventTrack({
                  category: categoryNames.header,
                  action: actionNames.click,
                  label: resource.name,
                });  
              }}> 
              <Space direction="vertical" align="center">
                <span
                  className="icon"
                  dangerouslySetInnerHTML={{__html: resource.icon}}
                ></span>
                  <Text>{resource.name}</Text>
                </Space>
              </a>
            </Col>
          )}
        </>
      )}
    </AppDrawerFormat>
  );
};

export default AppDrawer;
